<template>
    <div class="demand-item card">
        <div class="demand-title">
            <div class="demand-title__item" style="flex: 1">
                <div class="demand-title__item_name">城市</div>
                <div class="demand-title__item_value ellipsis">{{demand.city}}</div>
            </div>
            <div class="demand-title__item" style="flex: 1" v-if="demand.cost_label">
                <div class="demand-title__item_name">预算</div>
                <div class="demand-title__item_value ellipsis">{{demand.cost_label}}</div>
            </div>
            <div class="demand-title__item" style="flex: 2" v-if="demand.layout_label">
                <div class="demand-title__item_name">户型</div>
                <div class="demand-title__item_value ellipsis">{{demand.layout_label}}</div>
            </div>
        </div>
        <div class="demand-content">
            <div class="demand-content__description" v-if="demand.content">
                <div>{{demand.content}}</div>
            </div>
            <div class="demand-content__contact">
                <div class="demand-content__contact_name"><div style="opacity: .5">微信号</div> {{demand.contact}}</div>
            </div>
        </div>
        <div class="demand-info" v-if="demand.status == 0">
            <div class="demand-intro">
                <div v-if="demand.receive_count > 0">{{demand.receive_count}}人已接单，</div>
                请保持联系方式畅通
            </div>
            <div class="demand-btn" @click="revoke">撤 单</div>
        </div>
        <div class="demand-time" v-else>
            <div v-if="demand.status == 1" style="margin-left: 10px">已撤单</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['demand'],
        methods: {
            revoke () {
                this.$router.push({name: 'revokeDemand', params: {id: this.demand.id}})
            }
        }
    }
</script>

<style lang="less" scoped>
    .demand-time {
        font-size: 9pt;
        color: #999;
        margin-top: 10px;
        text-align: right;
    }

    .demand-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .demand-title__item {
            min-width: 0;
            .demand-title__item_name {
                font-size: 9pt;
                color: #999;
            }
            .demand-title__item_value {
                font-size: 13pt;
                min-width: 0;
                width: 100%;
            }
        }
    }
    .demand-content {
        border-radius: 4px;
        background-color: #f3f4f5;
        padding: 10px;
        .demand-content__description {
            font-size: 11pt;
            color: #333;
        }
    }

    .demand-layouts {
        overflow: hidden;
        margin-bottom: 10px;
        .demand-layouts__tag {
            float: left;
            background-color: #f3f4f5;
            padding: 4px 8px;
            border-radius: 4px;
            margin-right: 5px;
            margin-bottom: 5px;
            font-size: 9pt;
            color: #08979C;
        }
    }

    .demand-content__description {
        margin-bottom: 5px;
    }

    .demand-content__contact {
        display: flex;
        align-items: center;
        .demand-content__contact_icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;
        }
        .demand-content__contact_name {
            font-size: 10pt;
            color: #333;
        }
    }

    .demand-item {
        margin-top: 10px;
        padding: 15px;
        .demand-table__row {
            display: flex;
            justify-content: space-between;
            align-items: flext-start;
            padding: 10px 0;
            font-size: 11pt;
            .demand-table__row_name {
                color: #666;
            }
            .demand-table__row_value {
                color: #333;
            }
        }
        .demand-info {
            padding-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 5px;
            .demand-intro {
                color: #08979C;
                font-size: 10pt;
            }
            .demand-btn {
                background-color: #fff;
                font-size: 11pt;
                border-radius: 4px;
                padding: 2px 10px;
                border: 1px solid #eee;
            }
        }
    }
</style>


